<template>
    <tr>
        <td>
            <v-tooltip v-if="instance" top>
                <template v-slot:activator="{ on }">
                    <v-icon :color="getAppointmentStatusColor(instance.status)" class="mr-4" x-small v-on="on">
                        fas fa-calendar
                    </v-icon>
                </template>
                <template v-if="instance.status === 0">
                    <template v-if="isInstancePassed">Rendez-vous passé</template><template v-else>{{ getAppointmentStatusLabel(instance.status) }}</template><br>
                    Le {{ instance.startDate | toDayMonth() }} à {{ instance.startDate | toTime(false) }}
                </template>
                <template v-else>
                    {{ getAppointmentStatusLabel(instance.status) }}
                </template>
            </v-tooltip>
        </td>

        <td>
            {{ buyer.name }} {{ buyer.firstname }}

            <ConfirmationDialog v-if="instance && instance.status === 0 && !isInstancePassed" @confirm="cancelInstance()" text="Voulez-vous vraiment annuler ce rendez-vous ?">
                <template v-slot:activator="{ on: dialog }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn color="red" x-small text icon v-on="{ ...dialog, ...tooltip }">
                                <v-icon> mdi-calendar-remove </v-icon>
                            </v-btn>
                        </template>
                        Annuler le rendez-vous
                    </v-tooltip>
                </template>
            </ConfirmationDialog>
        </td>

        <td>
            <ConfirmationDialog v-if="!instance" @confirm="removeBuyer(buyer.email)" text="Voulez-vous vraiment retirer cet acquéreur de la session de rendez-vous ?">
                <template v-slot:activator="{ on: tooltip }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on: dialog }">
                            <v-btn class="ml-2" color="red" x-small text icon v-on="{ ...dialog, ...tooltip }">
                                <v-icon x-small> fas fa-times </v-icon>
                            </v-btn>
                        </template>
                        Supprimer
                    </v-tooltip>
                </template>
            </ConfirmationDialog>
        </td>
    </tr>
</template>

<script>
import { isBefore } from 'date-fns';
import appointmentMixin from '../../mixins/appointments.js';
import ConfirmationDialog from '../dialogs/ConfirmationDialog';

export default {
    name: 'ManageAppointmentSessionPlanningDialog',

    mixins: [appointmentMixin],

    components: {
        ConfirmationDialog
    },

    props: {
        appointment: { type: Object, required: true },
        buyer: { type: Object, required: true },
        instance: { type: Object }
    },

    data: () => ({
       
    }),

    computed: {
        isInstancePassed() {
            return isBefore(new Date(this.instance.endDate), new Date());
        }
    },

    methods: {
        async removeBuyer(email) {
            try {
                this.setLoading(true);

                const body = {
                    appointment: {
                        buyers: this.appointment.buyersIds.filter((e) => e !== email)
                    }
                };

                const { success, err } = await this.repos.appointments.updateAppointment(this.appointment.id, body);
                if (success) {
                    this.$notify({
                        title: 'Information',
                        text: 'L\'acquéreur a bien été retiré',
                        type: 'success'
                    });
                    this.$nextTick(() => {
                        this.$emit('deleted');
                    });
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de l\'ajout du nouvel acquéreur',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },

        async cancelInstance() {
            try {
                this.setLoading(true);

                const { success, err } = await this.repos.appointments.cancelAppointmentUser(this.instance.id);
                if (success) {
                    this.$nextTick(() => {
                        this.$emit('deleted');
                    });
                    this.isOpen = false;
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de la suppression du rendez-vous',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        }
    }
};
</script>
